(function(algolia) {
  'use strict';
  var rangeSlider = algolia.externals.widgets.rangeSlider;
  var menu = algolia.externals.widgets.menu;
  var refinementList = algolia.externals.widgets.refinementList;

  var TYPES_TO_WIDGET = {
    slider: { name: 'rangeSlider', useDefault: true, widget: rangeSlider },
    menu: { name: 'menu', params: { limit: 20 }, widget: menu },
    conjunctive: {
      name: 'refinementList',
      params: { operator: 'and', limit: 20 },
      widget: refinementList,
    },
    disjunctive: {
      name: 'refinementList',
      params: { operator: 'or', limit: 100 },
      widget: refinementList,
    },
  };

  var sortByRefined = function sortByRefined(sortFunction) {
    return function(a, b) {
      if (a.refined !== b.refined) {
        if (a.refined) {
          return -1;
        }
        if (b.refined) {
          return 1;
        }
      }
      return sortFunction(a, b);
    };
  };

  /*
   * Sorting functions : Allows to chose in which order you want to display the facets
   * Algolia will always send you back the most relevant values for each facet (the ones
   * with the highest count). These sorting functions won't change which results come back
   * but how they are displayed. To retrieve more results, change the maxValuesPerFacet
   * parameter in your Algolia Dashboard.
   * The default sort function is refined > count > name.
   */
  algolia.facetSortFunctions = {
    price_range: sortByRefined(function sortRanges(a, b) {
      if (a.name.length === b.name.length) {
        return a.name.localeCompare(b.name);
      }
      return a.name.length - b.name.length;
    }),
    'named_tags.ais-type': sortByRefined(function sortTypes(a, b) {
        return a.name.localeCompare(b.name);
    }),
    'named_tags.ais-gender': sortByRefined(function sortGenders(a, b) {
        return a.name.localeCompare(b.name);
    }),
    'named_tags.ais-age': sortByRefined(function sortAges(a, b) {
        var ages = {'0-3M': 1, '3-12M': 2, '12-24M': 3, '2-3T': 4, '4-5T': 5};
        var aPart = a.name.toUpperCase();
        var bPart = b.name.toUpperCase();
        if (ages.hasOwnProperty(aPart) && ages.hasOwnProperty(bPart)) {
            return ages[aPart] - ages[bPart];
        } else if (ages.hasOwnProperty(aPart)) {
            return -1;
        } else if (ages.hasOwnProperty(bPart)) {
            return 1;
        }

        return 0;
    }),
    'named_tags.ais-color': sortByRefined(function sortColors(a, b) {
        return a.name.localeCompare(b.name);
    }),
    'named_tags.ais-size': sortByRefined(function sortSizes(a, b) {
        var sizes = {'XXS': 1, 'XS': 2, 'S': 3, 'M': 4, 'L': 5, 'XL': 6, 'XXL': 7, 'XXXL': 8, '4-5T': 9};
        var aPart = a.name.toUpperCase();
        var bPart = b.name.toUpperCase();
        if (sizes.hasOwnProperty(aPart) && sizes.hasOwnProperty(bPart)) {
            return sizes[aPart] - sizes[bPart];
        } else if (sizes.hasOwnProperty(aPart)) {
            return -1;
        } else if (sizes.hasOwnProperty(bPart)) {
            return 1;
        }

        return 0;
    }),
  };

  /*
   * Display functions
   * When the object sent back for a facet item doesn't match how you would want it to look
   * like, use a function to reformat it how you want.
   */
  algolia.facetDisplayFunctions = {
    price_range: function displayRange(value) {
      var values = value.split(':');

      return values
        .map(function(e) {
          return algolia.formatMoney(Number(e) * 100).replace(/\.\d+/, '');
        })
        .join(' - ');
    },
    'named_tags.ais-size': function displaySize(value) {
        var sizes = {
            'XS': '<span class="letter">XS</span> <!--<span class="elaborate-size">3-6 months<br />(8-13 lbs, 18-26 inches)</span>-->',
            'S': '<span class="letter">S</span> <!--<span class="elaborate-size">4-8 months<br />(12-19 lbs, 25-29 inches)</span>-->',
            'M': '<span class="letter">M</span> <!--<span class="elaborate-size">6-12 months<br />(18-26 lbs, 29-33 inches)</span>-->',
            'L': '<span class="letter">L</span> <!--<span class="elaborate-size">12-24 months<br />(26-34 lbs, 33-37 inches)</span>-->',
            'XL': '<span class="letter">XL</span> <!--<span class="elaborate-size">2T-3T<br />(34+ lbs, 37-42 inches)</span>-->'
        };

        return '<span class="size">' + (sizes[value.toUpperCase()] || value) + '</span>';
    }
  };

  algolia.facetCssClasses = {
    root: 'ais-facet',
    header: 'ais-facet--header',
    body: 'ais-facet--body',
    item: 'ais-facet--item',
    label: 'ais-facet--label',
    checkbox: 'ais-facet--checkbox',
    active: 'ais-facet--active',
    count: 'ais-facet--count',
  };

  var enabledFacets = algolia.config.facets.filter(function(facet) {
    return facet.enabled || parseInt(facet.enabled, 10);
  });
    enabledFacets.unshift({
        "enabled": true,
        "name": "collections",
        "title": "Promotions",
        "type": "disjunctive",
        "available_types": [
            "disjunctive"
        ],
        "forgettable": null,
        "searchable": false,
        "refined_first": false
    });
  algolia.facets = enabledFacets.map(function(facet) {
    return algolia.assign({}, facet, {
      escapedName: encodeURIComponent(facet.name),
    });
  });
  algolia.shownFacets = algolia.facets.filter(function(facet) {
    return facet.type !== 'hidden';
  });
  algolia.hiddenFacets = algolia.config.facets.filter(function(facet) {
    return facet.type === 'hidden';
  });

  var facetToWidget = function(facet) {
    var widget = TYPES_TO_WIDGET[facet.type];
    var params = algolia.assign({}, widget.params);

    params.container =
      "[class~='ais-facet-" + facet.escapedName + "-container']";
    params.attribute = facet.name;
    params.templates = {};
    params.cssClasses = algolia.facetCssClasses;

    /**
     * Providing a custom "Show more" template to confirm to the custom
     * Hogan delimiter
     */
    params.templates.showMoreText = algolia.getTemplate(
      'instant_search_facet_show_more'
    );

    if (facet.searchable) {
      params.searchable = true;
      params.searchablePlaceholder = 'Search for ' + facet.title;
      params.templates.searchableNoResults = '<div> No matching for ' + facet.title + '</div>';
    }

    params.templates.header = function() {
      return facet.title;
    };

    if (!widget.useDefault) {
      params.templates.item = algolia.getTemplate('instant_search_facet_item');
    }

    if (algolia.facetSortFunctions[facet.name]) {
      params.sortBy = algolia.facetSortFunctions[facet.name];
    }

    var displayFunction = algolia.facetDisplayFunctions[facet.name];
    params.transformItems = function(items) {
      if (facet.name === 'product_type') {
          items = items.filter(function (item) { return !['N/A', 'OPTIONS_HIDDEN_PRODUCT'].includes(item.value) });
      }
      if (facet.name === 'options.size') {
          var sizes = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
          items = items.filter(function (item) {
              var size = item.value.split(' ')[0];

              return sizes.includes(size);
          });
      }
      if (facet.name === 'collections') {
          items = items.filter(function (item) { return item.value === 'sale'; });
      }
      return items.map(function(item) {
        var transformedItem = algolia.assign({}, item);
        transformedItem.type = {};
        transformedItem.type[facet.type] = true;
        transformedItem.label = displayFunction
          ? displayFunction(item.value)
          : item.value;
        transformedItem.is_color = facet.name === 'named_tags.ais-color';
        return transformedItem;
      });
    };

    return {
      name: widget.name,
      params: params,
      widget: widget.widget,
    };
  };

  // try to fetch facets for current collection or fallback to collections default
  var collection_facets =
    algolia.current_collection_id &&
    algolia.config.collection_facets &&
    algolia.config.collection_facets[algolia.current_collection_id]
      ? algolia.config.collection_facets[algolia.current_collection_id]
      : algolia.config.collection_facets &&
        algolia.config.collection_facets.default;

  if (collection_facets) {
    var enabledCollectionFacets = collection_facets.filter(function(facet) {
      return facet.enabled || parseInt(facet.enabled, 10);
    });
      enabledCollectionFacets.unshift({
          "enabled": true,
          "name": "collections",
          "title": "Promotions",
          "type": "disjunctive",
          "available_types": [
              "disjunctive"
          ],
          "forgettable": null,
          "searchable": false,
          "refined_first": false
      });

    algolia.collectionFacets = enabledCollectionFacets.map(function(facet) {
      return algolia.assign({}, facet, {
        escapedName: encodeURIComponent(facet.name),
      });
    });
    algolia.collectionShownFacets = algolia.collectionFacets.filter(function(
      facet
    ) {
      return facet.type !== 'hidden';
    });
    algolia.collectionHiddenFacets = collection_facets.filter(function(facet) {
      return facet.type === 'hidden';
    });
    algolia.collectionFacetsWidgets = algolia.collectionShownFacets.map(
      facetToWidget
    );
  }
  algolia.facetsWidgets = algolia.shownFacets.map(facetToWidget);
})(window.algoliaShopify);
